class UserBarDto {
    constructor(user, bar) {
        this.user = user._id;
        this.bar = bar._id;
    }
}

export default UserBarDto;
